import React from "react";
import PlataformaGruposPage from "../../leasecontrol/components/PlataformaGruposPage";
import { createWialonUnitGroup, getWialonUnitGroupHistory, listWialonUnitGroups, listWialonUnits, listWialonUsers, updateWialonUnitGroup } from "../services/wialonUsers";

export default function WialonGruposPage() {
  return (
    <PlataformaGruposPage
      title="Grupos"
      subtitle="Modulo de Wialon"
      listGroups={listWialonUnitGroups}
      createGroup={createWialonUnitGroup}
      updateGroup={updateWialonUnitGroup}
      getGroupHistory={getWialonUnitGroupHistory}
      listUsers={listWialonUsers}
      listUnits={listWialonUnits}
      providerColor="#006d75"
    />
  );
}
